import { FaArrowLeft, FaDownload } from "react-icons/fa";
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import SubLoading from './Loading/SubLoading';

const NoticePage = ({ notices }) => {
    const { id } = useParams();
    // const [document, setDocument] = useState(null);
    // const [image, setImage] = useState(null);
    let match;
    let notice;
    if (notices) {      
        match = notices.filter((item) => {
            return item.id === id
        });  
        
        notice = match[0]
        //console.log(id, notices, match)
    }     
    

    return ( 
        <div className="light-bg wrapper pt-5">
            {
                notice ? (
                    <>
                        <div className="box container">
                            <h6 className="subtitle has-text-weight-bold mb-2">{notice.topic}</h6>
                            <div className="divider"></div>
                            <div className="row">
                                <div className="col s12 m8 ">
                                    <p className="block grey-text text-darken-2 mt-5">
                                        {notice.body}
                                    </p>
                                </div>
                            </div>
                            {
                                notice.url  && (
                                    <div className="control mb-4">
                                        <a 
                                            className="button is-success mt-3"
                                            href={notice.url}
                                            download
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <span className="icon">
                                                <FaDownload color="white"/>
                                            </span>
                                            <span className="white-text">{notice.filename}</span>
                                        </a>
                                    </div>
                                )
                            }
                            <div className="mt-4">
                                <p className="grey-text light">{notice.date}</p>
                            </div>
                        </div>
                        <div className="container center">
                            <div className="control mb-4">
                                <Link to="/" className="button is-info mt-3">
                                    <span className="icon">
                                        <FaArrowLeft color="white"/>
                                    </span>
                                    <span className="white-text">Back</span>
                                </Link>
                            </div>
                        </div>   
                    </>

                ) : (
                    <SubLoading />
                )
            }
              
        </div>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        notices: state.firestore.ordered.notices
    }
    
}

export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "notices", 
            },
    ])
)(NoticePage);

